import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

// ✅ Move keyframes out here
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// ✅ Define styled component once, with props
const StyledSpinner = styled.div`
  margin: ${props => props.margin || "0px"};
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid grey;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
  border-left: 4px solid black;
  background: transparent;
  width: ${props => props.size || "30px"};
  height: ${props => props.size || "30px"};
  border-radius: 50%;
`;

const Spinner = (props) => {
  const [ShowSpinner, setShowSpinner] = useState(false);
  const [DisplayText, setDisplayText] = useState(null);
  const [DisplaySize, setDisplaySize] = useState("30px");
  const [Margin, setMargin] = useState("0px");

  useEffect(() => {
    setShowSpinner(props.showSpinner);
    setDisplayText(props.displayText);
    if (props.displaySize) setDisplaySize(props.displaySize);
    if (props.margin) setMargin(props.margin);
  }, [props.showSpinner, props.displayText, props.displaySize, props.margin]);

  return (
    <div>
      {ShowSpinner ? (
        <div className='align-items-center spinner1'>
          <StyledSpinner size={DisplaySize} margin={Margin} />
          {DisplayText}
        </div>
      ) : null}
    </div>
  );
};

export default Spinner;
